<app-page-content class="independent-scroll-page">
  <app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="loading$ | async">
    <div class="flex-1 flex-row items-center justify-start" left>
      <!-- Actions Menu for mobile/smaller screens -->
      <mat-menu #actionsMenu="matMenu" class="vertical-actions-menu">
        <mat-menu #addSection="matMenu">
          @for (type of optionalSectionTypes$ | async; track type.id) {
            <button (click)="appendSection(type)" type="button" mat-menu-item>
              {{ 'activity.section.type.' + getSectionTypeName(type.id) + '.title' | translate }}
            </button>
          }
        </mat-menu>
        <button
          [disabled]="(hasOUWritePermissions$ | async) === false"
          mat-menu-item
          type="button"
          [matMenuTriggerFor]="addSection"
          >
          <mat-icon>add</mat-icon>
          <span>{{ 'generic.add' | translate }}</span>
        </button>
        <button
          [disabled]="(hasOUWritePermissions$ | async) === false || (isOwner$ | async) === false"
          mat-menu-item
          type="button"
          (click)="save()"
          >
          <mat-icon>save</mat-icon>
          <span>{{ 'generic.save' | translate }}</span>
        </button>

        <mat-menu #copyMenu="matMenu">
          @if (
            (hasActivityCopyPermission$ | async) &&
            (hasOUWritePermissions$ | async) &&
            (activityOwner$ | async)?.organization_unit_id !== (currentOUDetails$ | async)?.id &&
            (currentOUDetails$ | async)?.parent_organization_unit_id !== null &&
            (activityDetails$ | async)?.replace_activity_id === null
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="forkActivity()"
            >
              <mat-icon>call_split</mat-icon>
              <span>{{ 'activity.fork' | translate }}</span>
            </button>
          }
          @if (
            (hasActivityCopyPermission$ | async) &&
            (hasOUWritePermissions$ | async) &&
            (activityOwner$ | async)?.organization_unit_id !== (currentOUDetails$ | async)?.id &&
            (currentOUDetails$ | async)?.parent_organization_unit_id !== null &&
            (activityDetails$ | async)?.replace_activity_id !== null
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="unforkActivity()"
            >
              <mat-icon>link_off</mat-icon>
              <span>{{ 'activity.unfork' | translate }}</span>
            </button>
          }
          @if ((activityDetails$ | async)?.replace_activity_id) {
            <button
              mat-menu-item
              type="button"
              (click)="viewOriginalActivity()"
            >
              <mat-icon>link</mat-icon>
              <span>{{ 'activity.view_original' | translate }}</span>
            </button>
          }
          @if (
            (isDoenkidsManagement$ | async) ||
            (((hasOUWritePermissions$ | async) ||
              (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) ||
              (hasWritePermissionOnAtLeastOneLocationOUInCurrentNodeTree$ | async)) &&
              (hasActivityCopyPermission$ | async))
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="copyActivityWithFields()"
            >
              <mat-icon>content_copy</mat-icon>
              <span>{{ 'activity.copy_with_fields' | translate }}</span>
            </button>
          }
        </mat-menu>
        @if (
          (isDoenkidsManagement$ | async) ||
          (hasActivityCopyPermission$ | async)
        ) {
          <button
            mat-menu-item
            type="button"
            [matMenuTriggerFor]="copyMenu"
          >
            <mat-icon>content_copy</mat-icon>
            <span>{{ 'activity.copy.menu' | translate }}</span>
          </button>
        }
        <button mat-menu-item type="button" (click)="downloadPDF()">
          <mat-icon>get_app</mat-icon>
          <span>{{ 'activity.pdf.download.tooltip' | translate }}</span>
        </button>
        @if (isOwner$ | async) {
          <button mat-menu-item type="button" (click)="reviewByOrganisation()">
            <mat-icon>preview</mat-icon>
            <span>{{ 'activity.review.tooltip' | translate }}</span>
          </button>
        }
        @if ((isLocation$ | async) && (activityDetails$ | async)?.status_id === publishedStatus) {
          <button
            mat-menu-item
            type="button"
            (click)="createProgram()"
          >
            <mat-icon>date_range</mat-icon>
            <span>{{ 'activity.create-program.tooltip' | translate }}</span>
          </button>
        }
      </mat-menu>

      <!-- Actions menu trigger button for smaller screens -->
      <button
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="actionsMenu"
        [matTooltip]="'activity.actions' | translate"
        class="actions-menu-button"
        >
        <mat-icon>more_vert</mat-icon>
      </button>

      <!-- Individual action buttons for larger screens -->
      <div class="individual-actions">
        <mat-menu #addSectionDesktop="matMenu">
          @for (type of optionalSectionTypes$ | async; track type.id) {
            <button (click)="appendSection(type)" type="button" mat-menu-item>
              {{ 'activity.section.type.' + getSectionTypeName(type.id) + '.title' | translate }}
            </button>
          }
        </mat-menu>
        <button
          [disabled]="(hasOUWritePermissions$ | async) === false"
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="addSectionDesktop"
          [matTooltip]="'generic.add' | translate"
          >
          <mat-icon>add</mat-icon>
        </button>
        <button
          [disabled]="(hasOUWritePermissions$ | async) === false || (isOwner$ | async) === false"
          mat-icon-button
          type="button"
          (click)="save()"
          [matTooltip]="'generic.save' | translate"
          >
          <mat-icon>save</mat-icon>
        </button>
        <!-- Copy Menu for desktop -->
        <mat-menu #copyMenuDesktop="matMenu">
          @if (
            (hasActivityCopyPermission$ | async) &&
            (hasOUWritePermissions$ | async) &&
            (activityOwner$ | async)?.organization_unit_id !== (currentOUDetails$ | async)?.id &&
            (currentOUDetails$ | async)?.parent_organization_unit_id !== null &&
            (activityDetails$ | async)?.replace_activity_id === null
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="forkActivity()"
            >
              <mat-icon>call_split</mat-icon>
              <span>{{ 'activity.fork' | translate }}</span>
            </button>
          }
          @if (
            (hasActivityCopyPermission$ | async) &&
            (hasOUWritePermissions$ | async) &&
            (activityOwner$ | async)?.organization_unit_id !== (currentOUDetails$ | async)?.id &&
            (currentOUDetails$ | async)?.parent_organization_unit_id !== null &&
            (activityDetails$ | async)?.replace_activity_id !== null
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="unforkActivity()"
            >
              <mat-icon>link_off</mat-icon>
              <span>{{ 'activity.unfork' | translate }}</span>
            </button>
          }
          @if ((activityDetails$ | async)?.replace_activity_id) {
            <button
              mat-menu-item
              type="button"
              (click)="viewOriginalActivity()"
            >
              <mat-icon>link</mat-icon>
              <span>{{ 'activity.view_original' | translate }}</span>
            </button>
          }
          @if (
            (isDoenkidsManagement$ | async) ||
            (((hasOUWritePermissions$ | async) ||
              (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) ||
              (hasWritePermissionOnAtLeastOneLocationOUInCurrentNodeTree$ | async)) &&
              (hasActivityCopyPermission$ | async))
          ) {
            <button
              mat-menu-item
              type="button"
              (click)="copyActivityWithFields()"
            >
              <mat-icon>content_copy</mat-icon>
              <span>{{ 'activity.copy_with_fields' | translate }}</span>
            </button>
          }
        </mat-menu>
        @if (
          (isDoenkidsManagement$ | async) ||
          (hasActivityCopyPermission$ | async)
        ) {
          <button
            mat-icon-button
            type="button"
            [matMenuTriggerFor]="copyMenuDesktop"
            [matTooltip]="'activity.copy.menu' | translate"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          type="button"
          (click)="downloadPDF()"
          [matTooltip]="'activity.pdf.download.tooltip' | translate"
          >
          <mat-icon>get_app</mat-icon>
        </button>
        @if (isOwner$ | async) {
          <button
            mat-icon-button
            type="button"
            (click)="reviewByOrganisation()"
            [matTooltip]="'activity.review.tooltip' | translate"
          >
            <mat-icon>preview</mat-icon>
          </button>
        }
        @if ((isLocation$ | async) && (activityDetails$ | async)?.status_id === publishedStatus) {
          <button
            mat-icon-button
            type="button"
            (click)="createProgram()"
            [matTooltip]="'activity.create-program.tooltip' | translate"
          >
            <mat-icon>date_range</mat-icon>
          </button>
        }
      </div>

      @if (possibleContentLanguages$ | async; as contentLanguages) {
        @if ((hasOUWritePermissions$ | async) && contentLanguages.length > 1) {
          <mat-form-field
            appearance="outline"
            class="compact-select content-language-select"
            >
            <mat-label>{{ 'activity.content_language.label' | translate }}</mat-label>
            <mat-select [formControl]="contentLanguageControl">
              @if (contentLanguageControl.value) {
                <mat-select-trigger>
                  <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                  {{ 'generic.language.' + contentLanguageControl.value.toLowerCase()| translate }}
                </mat-select-trigger>
              }
              @for (contentLanguage of contentLanguages; track contentLanguage) {
                <mat-option
                  [value]="contentLanguage"
                  >
                  <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
                  {{ 'generic.language.' + contentLanguage.toLowerCase() | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }

      @if (!(showMobileLayout$ | async)) {
        @if (activityDetails$ | async; as activityDetails) {
          <!-- Activity owner-->
          @if (!(activityDetails?.replace_activity_id !== null && (hasActivityCopyPermission$ | async)) || (isAdmin$ | async)) {
            @if ((activityOwnerIds$ | async)?.length) {
              <app-owner-chip
                [owningOuIds]="activityOwnerIds$ | async"
                [owningOuRoles]="activityPermissions$ | async"
              ></app-owner-chip>
            }
          }
          <!-- Activity status-->
          @if (activityDetails?.status_id; as statusId) {
            <app-status-chip
              [statusName]="getActivityStatusName(statusId)"
              [translationKey]="'activity.status.' + getActivityStatusName(statusId)"
            ></app-status-chip>
            @if (hasOUWritePermissions$ | async) {
              <app-publish-button
                [currentStatusName]="getActivityStatusName(statusId)"
                [hasWriteAccess]="hasOUWritePermissions$ | async"
                [statusOptions]="getActivityStatusOptionsForMenu(statusId)"
                [publishTooltip]="getActivityStatusName(statusId) === 'published' ? ('activity.status.already_published' | translate) : ('activity.status.publish' | translate)"
                [optionsTooltip]="'activity.status.options' | translate"
                menuId="activityStatusOptionsMenu"
                (publish)="publishActivity()"
                (statusSelected)="onActivityStatusChange($event)"
              ></app-publish-button>
            }
          }
          @if (activityDetails?.status_id === EActivityStatusType.REVIEW) {
            <button mat-stroked-button class="status-button review">
              {{ 'activity.status.review.reviewed_by' | translate: { user: activityCreatedByUser, organization: activityCreatedByOU } }}
            </button>
          }
        }
      }

      <mat-menu #activityCustomer="matMenu">
        @if (currentOUDetails$ | async; as currentOrganization) {
          @if (activityDetails$ | async; as activityDetails) {
            @if (
              activityDetails?.replace_activity_id === null &&
              currentOrganization.id !== 1 &&
              currentOrganization.id !== (activityOwner$ | async)?.organization_unit_id
              ) {
              <button
                mat-menu-item
                type="button"
                (click)="changeActivityOwner(currentOrganization.id)"
                >
                {{ 'activity.owner.change.to_current_organization' | translate: { organization: currentOrganization?.name } }}
              </button>
            }
            @if (activityDetails?.replace_activity_id === null && (activityOwner$ | async)?.organization_unit_id !== 1 && (isAdmin$ | async)) {
              <button
                mat-menu-item
                type="button"
                (click)="changeActivityOwner(1)"
                >
                {{ 'activity.owner.change.to_doenkids' | translate }}
              </button>
            }
            @if (currentOrganization.id === (activityOwner$ | async)?.organization_unit_id) {
              <span mat-menu-item>
                {{ 'activity.owner.change.error.already_owned_by_current' | translate: { organization: currentOrganization?.name } }}
              </span>
            }
          }
        }
      </mat-menu>
    </div>
    @if (activityDetails$ | async; as activityDetails) {
      <div right>
        @if (activityDetails?.status_id === EActivityStatusType.PUBLISHED && (hasOUWritePermissions$ | async)) {
          <button
            mat-icon-button
            type="button"
            (click)="shareActivity()"
            [matTooltip]="'activity.share.tooltip' | translate"
          >
            <mat-icon>share</mat-icon>
          </button>
        }
        <button mat-icon-button type="button" (click)="showEventLog()" [matTooltip]="'activity.event_log.view.tooltip' | translate">
          <mat-icon>assignment</mat-icon>
        </button>
        @if (
          activityDetails?.replace_activity_id === null &&
          !(isDoenkidsManagement$ | async) &&
          !(isCurrentOrganizationUnitIsOfTypeLocation$ | async) &&
          !(isCurrentOrganizationUnitIsOfTypeGroup$ | async)
          ) {
          <button
            mat-icon-button
            type="button"
            (click)="excludeActivity()"
            [matTooltip]="'activity.exclude.tooltip' | translate"
            >
            <mat-icon>remove_circle</mat-icon>
          </button>
        }
        @if ((isDoenkidsManagement$ | async) || (hasOUWritePermissions$ | async)) {
          <button
            mat-icon-button
            type="button"
            (click)="deleteActivity()"
            [matTooltip]="'activity.delete.tooltip' | translate"
            >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
  </app-doenkids-menu-bar>
<div content>

<app-split-page [leftLabel]="'activity.details' | translate" [rightLabel]="'activity.preview' | translate" [independentScroll]="true" (selectedTabChange)="tabChange($event)">
  <ng-template #left>
    <form [formGroup]="activityForm" class="details-form-wrapper">
      <div class="details-container">
        <!-- Mobile chips section -->
        @if (showMobileLayout$ | async) {
          @if (activityDetails$ | async; as activityDetails) {
            <div class="mobile-chips-section">
              <div class="flex-row items-center justify-start flex-wrap gap-2">
                @if (!(activityDetails?.replace_activity_id !== null && (hasActivityCopyPermission$ | async)) || (isAdmin$ | async)) {
                  @if ((activityOwnerIds$ | async)?.length) {
                    <app-owner-chip
                      [owningOuIds]="activityOwnerIds$ | async"
                      [owningOuRoles]="activityPermissions$ | async"
                    ></app-owner-chip>
                  }
                }
                @if (activityDetails?.status_id; as statusId) {
                  <app-status-chip
                    [statusName]="getActivityStatusName(statusId)"
                    [translationKey]="'activity.status.' + getActivityStatusName(statusId)"
                  ></app-status-chip>
                  @if (hasOUWritePermissions$ | async) {
                    <app-publish-button
                      [currentStatusName]="getActivityStatusName(statusId)"
                      [hasWriteAccess]="hasOUWritePermissions$ | async"
                      [statusOptions]="getActivityStatusOptionsForMenu(statusId)"
                      [publishTooltip]="getActivityStatusName(statusId) === 'published' ? ('activity.status.already_published' | translate) : ('activity.status.publish' | translate)"
                      [optionsTooltip]="'activity.status.options' | translate"
                      menuId="activityStatusOptionsMenuMobile"
                      (publish)="publishActivity()"
                      (statusSelected)="onActivityStatusChange($event)"
                    ></app-publish-button>
                  }
                }
              </div>
            </div>
          }
        }
        <!-- Outdated Activity Warning Banner (only for users who can edit/plan activities) -->
        @if ((canSeeOutdatedBanner$ | async) && (bannerInfo$ | async); as bannerInfo) {
          <div
            class="outdated-banner"
            [class.outdated-banner--deleted]="bannerInfo.isDeleted"
            [class.outdated-banner--updated]="bannerInfo.isUpdated"
            [style.display]="bannerInfo.shouldShow ? 'flex' : 'none'"
          >
            @if (bannerInfo.isDeleted) {
              <mat-icon>warning</mat-icon>
              <div class="outdated-banner__content">
                <strong>{{ 'activity.outdated.deleted.title' | translate }}</strong>
                <p>{{ 'activity.outdated.deleted.description' | translate }}</p>
              </div>
            }
            @if (bannerInfo.isUpdated) {
              <mat-icon>info</mat-icon>
              <div class="outdated-banner__content">
                <strong>{{ 'activity.outdated.updated.title' | translate }}</strong>
                <p>{{ 'activity.outdated.updated.description' | translate }}</p>
                <div class="outdated-banner__actions">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="viewOriginalActivity()"
                    class="outdated-banner__link"
                  >
                    {{ 'activity.outdated.view_original' | translate }}
                  </button>
                  @if (!bannerInfo.isActivityArchived) {
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="recopyActivity()"
                      class="outdated-banner__recopy"
                    >
                      {{ 'activity.outdated.recopy.button' | translate }}
                    </button>
                  }
                  <button
                    mat-button
                    (click)="dismissOriginalUpdatedNotification()"
                    class="outdated-banner__dismiss"
                  >
                    {{ 'activity.outdated.dismiss' | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        }

        @if (isDoenkidsManagement$ | async) {
          <app-activity-example-usage
            [usage]="exampleProgramTemplateUsage$ | async"
            [loading]="(exampleProgramTemplateUsageLoading$ | async) ?? false"
            [maxUsageCount]="maxExampleUsageCount"
          ></app-activity-example-usage>
        }

        <!-- Generic Activity Details (e.g. name, subtitle)-->
        <app-activity-controls
          #activityControls
          (initialized)="listenToForms($event)"
          (attachmentsUpdated)="renderAttachments()"
          (sectionSaved)="onActivityControlsSaved()"
          [activityDetails$]="activityDetails$"
        ></app-activity-controls>
        <!-- Sections -->
        @if (activitySectionList$ | async; as activitySections) {
          <app-panel-container
            formGroupName="sections"
            cdkDropList
            [cdkDropListData]="activitySections"
            (cdkDropListDropped)="dropSection($event)"
            >
            <ng-template let-sectionIndex="index">
              @if (activitySections[sectionIndex]; as section) {
                @if (section?.type_id !== ESectionType.BASIC_DETAILS) {
                  <mat-expansion-panel cdkDrag cdkDragLockAxis="y" class="section-panel">
                    <mat-expansion-panel-header [class.panel-with-description]="section?.type_id === ESectionType.MEDIA">
                      <mat-panel-title [class.panel-title-with-info]="sectionsWithInfoDialog.includes(section?.type_id)">
                        <app-drag-handle cdkDragHandle></app-drag-handle>
                        <span>
                          {{ 'activity.section.type.' + getSectionTypeName(section?.type_id) + '.title' | translate }}
                          @if (section?.type_id === ESectionType.PAGE_END) {
                            ............................................................
                          }
                        </span>
                        @if (sectionsWithInfoDialog.includes(section?.type_id)) {
                          <mat-icon (click)="openInfoWindow($event, section?.type_id)">info</mat-icon>
                        }
                      </mat-panel-title>
                      @if (activityForm.get('sections').get(section?.id?.toString())?.value?.data; as sectionForm) {
                        <mat-panel-description>
                          @if (section?.type_id !== ESectionType.MEDIA) {
                            <span>{{ sectionForm.title }}</span>
                          }
                          @if (section?.type_id === ESectionType.MEDIA) {
                            <span>
                              {{ 'activity.section.type.media.info' | translate }}
                            </span>
                          }
                        </mat-panel-description>
                      }
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <!-- If this section is an image section, we'll need to be able to drag and drop images all throughout the section. -->
                      @if (section?.type_id === ESectionType.MEDIA) {
                        <app-asset-upload
                          [identifier]="section.id.toString()"
                          [disabled]="(hasOUWritePermissions$ | async) === false"
                          >
                          <!-- Declare a context variable uploadData, and pass it the "uploadData" from the app-asset-upload component -->
                          <ng-template let-uploadData="uploadData">
                            <!-- Then pass this uploadData to the section, which pass it to the image section. -->
                            <app-section
                              (archived)="removeSection(section)"
                              (saved)="saveSectionFromTemplate(section.id, $event)"
                              [section]="section"
                              [formControlName]="section.id"
                              [uploadData]="uploadData"
                            ></app-section>
                          </ng-template>
                        </app-asset-upload>
                      }
                      @if (section?.type_id !== ESectionType.MEDIA && section?.type_id !== ESectionType.PAGE_END) {
                        <app-section
                          (saved)="saveSectionFromTemplate(section.id, $event)"
                          (archived)="removeSection(section)"
                          [activitySectionCount]="activitySectionCount$ | async"
                          [activitySectionTypes]="optionalSectionTypes$ | async"
                          [section]="section"
                          [formControlName]="section.id"
                          >
                        </app-section>
                      }
                      @if (section?.type_id === ESectionType.PAGE_END) {
                        <div class="button-container">
                          <button (click)="removeSection(section)" mat-button type="button">
                            {{ 'activity.section.remove.page_end' | translate }}
                          </button>
                        </div>
                      }
                    </ng-template>
                  </mat-expansion-panel>
                }
              }
            </ng-template>
          </app-panel-container>
        }
      </div>
    </form>

    <app-ai-adjustment-dock
      [availability]="aiAvailability$ | async"
      [allowedToEdit]="(aiEditingAllowed$ | async) === true"
      [disabled]="(aiRequestInFlight$ | async) === true"
      (submitted)="requestAiAdjustment($event)"
    ></app-ai-adjustment-dock>
  </ng-template>
  <ng-template #right>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedPdfTabIndex" (selectedIndexChange)="renderPdfTab($event)">
        <mat-tab [label]="'activity.label' | translate">
          <div class="pdf-container">
            @if(selectedPdfTabIndex === 0) {
              <app-pdf-viewer
                [pdfSrc]="activityPdf$ | async"
                [loading]="activityLoading"
                (pdfLoaded)="onPdfLoadedEvent('activity')"
              ></app-pdf-viewer>
            }
          </div>
        </mat-tab>
        <mat-tab [label]="'generic.attachments' | translate">
          <div class="pdf-container" *noContent="!(controls?.activityAttachments$ | async)?.length">
            @if (selectedPdfTabIndex === 1) {
              <app-pdf-viewer
                [pdfSrc]="attachmentPdf$ | async"
                [loading]="attachmentsLoading"
                (pdfLoaded)="onPdfLoadedEvent('attachment')"
              ></app-pdf-viewer>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
  </app-split-page>

</div>
</app-page-content>
